import { useState } from 'react'
import { Alert, Button, Modal, Spinner } from 'react-bootstrap'

import uploadIcon from '../../../imgs/upload.svg'
import { uploadFile } from '../../../services/files'

export function ReturnPackageModal({ item, createPackageReqMutation, handleClose }) {
  const [receiptFile, setReceiptFile] = useState(null)
  const [receiptFileURL, setReceiptFileURL] = useState(null)
  const [dotFileTypeState, setDotFileTypeState] = useState('')
  const [showImgView, setShowImgView] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)

  const receiptViewHandler = async e => {
    setShowImgView(false)
    const file = e.target.files[0]
    if (!file) return

    // Check for allowed file formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      setErrorMsg('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      return
    }

    setReceiptFile(file)
    let dotFileType = file.name
    dotFileType = dotFileType.substring(dotFileType.lastIndexOf('.'), dotFileType.length)
    setDotFileTypeState(dotFileType)

    // Different UI for image and PDF
    if (dotFileType !== '.pdf') {
      setReceiptFileURL(URL.createObjectURL(file))
      setShowImgView(true)
    }
    setErrorMsg('')
  }

  const submitHandler = async () => {
    if (!receiptFile) {
      setErrorMsg('אנא בחר קובץ להעלאה')
      return
    }

    // Check for allowed file formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(receiptFile.type)) {
      setErrorMsg('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      return
    }

    try {
      setIsProcessing(true)
      setErrorMsg('')

      // Upload receipt to S3
      const result = await uploadFile(receiptFile, item.id + dotFileTypeState)

      // Check if file uploaded successfully
      if (!result.Location) {
        throw new Error('Failed to upload file')
      }
      const data = {
        packageId: item.id,
        reqType: 'returnRequest',
        returnLabel: result.Location,
      }

      await createPackageReqMutation(data)

      alert('Return label uploaded successfully!')
      handleClose()
    } catch (error) {
      console.log('Error uploading return label:', error)
      setErrorMsg('הייתה שגיאה בהעלאת הקובץ. אנא נסה שנית.')
    } finally {
      setIsProcessing(false)
    }
  }

  return (
    <Modal size='lg' show={!!item} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Return Package</Modal.Title>
      </Modal.Header>
      {item && (
        <Modal.Body>
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '20px' }}>
              <strong>Package: {item.trackingNumberToIsrael}</strong>
              <br />
              <span>Brand: {item.brand}</span>
            </div>

            {!receiptFile && (
              <div style={{ marginBottom: '20px' }}>
                <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>Upload Return Label</div>
                <div
                  style={{
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    padding: '20px',
                    cursor: 'pointer',
                    backgroundColor: '#f9f9f9',
                  }}
                  onClick={() => {
                    document.getElementById(`returnReceiptInput`).click()
                  }}
                >
                  <img src={uploadIcon} alt='upload' style={{ width: '40px', marginBottom: '10px' }} />
                  <div style={{ fontWeight: 'bold' }}>Drag and drop file or click to choose</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Pdf file only</div>
                </div>
              </div>
            )}

            <input type='file' id='returnReceiptInput' style={{ display: 'none' }} onChange={receiptViewHandler} accept='image/*,.pdf' />

            {receiptFile && (
              <div style={{ marginBottom: '20px' }}>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Selected file: {receiptFile.name}</strong>
                  <Button
                    variant='outline-secondary'
                    size='sm'
                    onClick={() => {
                      setReceiptFile(null)
                      setReceiptFileURL(null)
                      setShowImgView(false)
                      setDotFileTypeState('')
                    }}
                    style={{ marginRight: '10px' }}
                  >
                    Change file
                  </Button>
                </div>

                {showImgView && (
                  <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                    <img
                      src={receiptFileURL}
                      alt='receipt preview'
                      style={{ maxWidth: '100%', maxHeight: '200px', border: '1px solid #ccc' }}
                    />
                  </div>
                )}

                {dotFileTypeState === '.pdf' && (
                  <div style={{ padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
                    <strong>Selected pdf file</strong>
                    <br />
                    <span style={{ fontSize: '14px' }}>The file will be uploaded after approval</span>
                  </div>
                )}
              </div>
            )}

            {errorMsg && (
              <Alert variant='danger' style={{ marginBottom: '15px' }}>
                {errorMsg}
              </Alert>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <Button onClick={submitHandler} disabled={isProcessing || !receiptFile} variant='primary'>
                {isProcessing ? (
                  <>
                    <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' style={{ marginLeft: '5px' }} />
                    Uploading...
                  </>
                ) : (
                  'Upload return label'
                )}
              </Button>
              <Button variant='secondary' onClick={handleClose} disabled={isProcessing}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      )}
    </Modal>
  )
}
